import { AllieIconProps } from '../../../components';

export const DislikeIcon: React.FC<AllieIconProps> = ({ size = 24 }) => (
  <svg
    className="fill-icon"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="bxs:dislike">
      <path
        id="Vector"
        // eslint-disable-next-line max-len
        d="M20 3H19V16H20C20.5304 16 21.0391 15.7893 21.4142 15.4142C21.7893 15.0391 22 14.5304 22 14V5C22 4.46957 21.7893 3.96086 21.4142 3.58579C21.0391 3.21071 20.5304 3 20 3ZM4 16H11L9.878 19.368C9.77789 19.6686 9.75061 19.9887 9.79843 20.3018C9.84624 20.615 9.96778 20.9124 10.153 21.1694C10.3383 21.4264 10.5819 21.6358 10.8639 21.7802C11.1459 21.9246 11.4582 21.9999 11.775 22H12L17 16.562V3H6L2.063 11.649L2 11.942V14C2 14.5304 2.21071 15.0391 2.58579 15.4142C2.96086 15.7893 3.46957 16 4 16Z"
        fill="#D0D5DD"
      />
    </g>
  </svg>
);
